// Address Actions
export const FETCH_ADDRESSES_REQUEST = 'FETCH_ADDRESSES_REQUEST'
export const FETCH_ADDRESSES_SUCCESS = 'FETCH_ADDRESSES_SUCCESS'
export const FETCH_ADDRESSES_FAILURE = 'FETCH_ADDRESSES_FAILURE'

export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST'
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS'
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE'

export const UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST'
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS'
export const UPDATE_ADDRESS_FAILURE = 'UPDATE_ADDRESS_FAILURE'

export const DELETE_ADDRESS_REQUEST = 'DELETE_ADDRESS_REQUEST'
export const DELETE_ADDRESS_SUCCESS = 'DELETE_ADDRESS_SUCCESS'
export const DELETE_ADDRESS_FAILURE = 'DELETE_ADDRESS_FAILURE'
